<script setup lang="ts">
import { pb } from "@/utils/PocketBaseAdapter";
import { useUserStore } from "@/utils/UserStore";

const props = defineProps<{
  modelValue: boolean;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: boolean): void;
}>();

const { fetchLoggedInUser } = useUserStore();
const subscribed = ref(true);

const handleClose = async () => {
  try {
    await pb.collection("users").update(pb?.authStore?.model?.id, {
      askedAboutNewsletters: true,
    });
    await fetchLoggedInUser();

    try {
      const userId = pb?.authStore?.model?.id;
      const existing = await pb.collection("notifications").getFirstListItem(`user="${userId}"`).catch(() => null);
      if (existing) {
        await pb.collection("notifications").update(existing.id, { newsletters: subscribed.value ? 1 : 0 });
      } else {
        await pb.collection("notifications").create({ user: userId, newsletters: subscribed.value ? 1 : 0 });
      }
    } catch {
      // Non-fatal — newsletter preference not saved but dialog should still close
    }
  } catch (e) {
    console.error("NewsletterSubscribeDialog error:", e);
  }
  emit("update:modelValue", false);
};
</script>

<template>
  <VDialog :model-value="props.modelValue" max-width="420px" persistent>
    <VCard>
      <div
        class="d-flex align-center justify-space-between bg-dialogHeaderColor"
      >
        <VCardTitle>Subscribe to our newsletter</VCardTitle>
      </div>
      <VCardText>
        <VCheckbox
          v-model="subscribed"
          label="Yes, I'd like to receive newsletters"
          hide-details
        />
      </VCardText>
      <VCardActions>
        <VSpacer />
        <VBtn color="primary" variant="flat" @click="handleClose">OK</VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>
